/**
 * Fired on window when the signed-in session is cleared (logout, forced
 * sign-out). Per-user UI state that outlives a render (text size, the
 * "adopt the profile once" latches) resets on it, so the next person on a
 * shared PC does not inherit the previous user's settings.
 *
 * Kept in its own module so contexts can listen without importing the
 * session code.
 */
export const SESSION_CLEARED_EVENT = 'jarvis:session-cleared';

/**
 * Fired on window after a sign-in stores the new tokens, without a reload.
 * Providers that read the profile (text size, theme) enable their query on
 * it, so the signed-in user's values are adopted right away.
 */
export const SESSION_STARTED_EVENT = 'jarvis:session-started';
